import { render } from "./PlatesList.vue?vue&type=template&id=7c1206a1&scoped=true"
import script from "./PlatesList.vue?vue&type=script&lang=js"
export * from "./PlatesList.vue?vue&type=script&lang=js"

import "./PlatesList.vue?vue&type=style&index=0&id=7c1206a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1206a1"]])

export default __exports__